import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6127805e = () => interopDefault(import('../../../pages/callback.vue' /* webpackChunkName: "pages/callback" */))
const _3b967dac = () => interopDefault(import('../../../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _105f4114 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _bf4489ce = () => interopDefault(import('../../../pages/financials/index.vue' /* webpackChunkName: "pages/financials/index" */))
const _a1adbbd8 = () => interopDefault(import('../../../pages/fund/index.vue' /* webpackChunkName: "pages/fund/index" */))
const _1cd0781c = () => interopDefault(import('../../../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _58744c7d = () => interopDefault(import('../../../pages/surveys.vue' /* webpackChunkName: "pages/surveys" */))
const _00403d0d = () => interopDefault(import('../../../pages/temporarily-down.vue' /* webpackChunkName: "pages/temporarily-down" */))
const _667c78a9 = () => interopDefault(import('../../../pages/ui-kit.vue' /* webpackChunkName: "pages/ui-kit" */))
const _1657b89a = () => interopDefault(import('../../../pages/settings/applications.vue' /* webpackChunkName: "pages/settings/applications" */))
const _5a67d912 = () => interopDefault(import('../../../pages/settings/join-movement.vue' /* webpackChunkName: "pages/settings/join-movement" */))
const _62d8d9ca = () => interopDefault(import('../../../pages/settings/payout-methods.vue' /* webpackChunkName: "pages/settings/payout-methods" */))
const _9c2269e8 = () => interopDefault(import('../../../pages/settings/profile/index.vue' /* webpackChunkName: "pages/settings/profile/index" */))
const _d784345a = () => interopDefault(import('../../../pages/settings/security/index.vue' /* webpackChunkName: "pages/settings/security/index" */))
const _0e6bb13b = () => interopDefault(import('../../../pages/financials/payments/history.vue' /* webpackChunkName: "pages/financials/payments/history" */))
const _639d08b1 = () => interopDefault(import('../../../pages/settings/profile/address/index.vue' /* webpackChunkName: "pages/settings/profile/address/index" */))
const _7cc96868 = () => interopDefault(import('../../../pages/settings/profile/basic.vue' /* webpackChunkName: "pages/settings/profile/basic" */))
const _1aa39116 = () => interopDefault(import('../../../pages/settings/profile/basic_household_info.vue' /* webpackChunkName: "pages/settings/profile/basic_household_info" */))
const _3a8e624c = () => interopDefault(import('../../../pages/settings/profile/contact.vue' /* webpackChunkName: "pages/settings/profile/contact" */))
const _1c98998e = () => interopDefault(import('../../../pages/settings/profile/contact_address_info.vue' /* webpackChunkName: "pages/settings/profile/contact_address_info" */))
const _6795ce5c = () => interopDefault(import('../../../pages/settings/profile/household/index.vue' /* webpackChunkName: "pages/settings/profile/household/index" */))
const _eea6e9be = () => interopDefault(import('../../../pages/settings/profile/notification.vue' /* webpackChunkName: "pages/settings/profile/notification" */))
const _20ce9735 = () => interopDefault(import('../../../pages/settings/security/privacy-legal.vue' /* webpackChunkName: "pages/settings/security/privacy-legal" */))
const _b53dff5e = () => interopDefault(import('../../../pages/settings/security/questions/index.vue' /* webpackChunkName: "pages/settings/security/questions/index" */))
const _37b8582d = () => interopDefault(import('../../../pages/settings/profile/address/create.vue' /* webpackChunkName: "pages/settings/profile/address/create" */))
const _9a4f703c = () => interopDefault(import('../../../pages/settings/profile/household/create.vue' /* webpackChunkName: "pages/settings/profile/household/create" */))
const _2c8154db = () => interopDefault(import('../../../pages/settings/security/questions/edit.vue' /* webpackChunkName: "pages/settings/security/questions/edit" */))
const _0dc72f0e = () => interopDefault(import('../../../pages/settings/profile/address/_uuid.vue' /* webpackChunkName: "pages/settings/profile/address/_uuid" */))
const _05d5a3b8 = () => interopDefault(import('../../../pages/settings/profile/household/_uuid.vue' /* webpackChunkName: "pages/settings/profile/household/_uuid" */))
const _55a800e8 = () => interopDefault(import('../../../pages/financials/contracts/_contractid/index.vue' /* webpackChunkName: "pages/financials/contracts/_contractid/index" */))
const _5f57d67a = () => interopDefault(import('../../../pages/financials/offers/_offerid/index.vue' /* webpackChunkName: "pages/financials/offers/_offerid/index" */))
const _7b3e118e = () => interopDefault(import('../../../pages/financials/payments/_paymentid/index.vue' /* webpackChunkName: "pages/financials/payments/_paymentid/index" */))
const _2e137d91 = () => interopDefault(import('../../../pages/financials/uf/_accountid/index.vue' /* webpackChunkName: "pages/financials/uf/_accountid/index" */))
const _0adb3282 = () => interopDefault(import('../../../pages/financials/uf/_accountid/confirm.vue' /* webpackChunkName: "pages/financials/uf/_accountid/confirm" */))
const _ae538362 = () => interopDefault(import('../../../pages/fund/_slug/index.vue' /* webpackChunkName: "pages/fund/_slug/index" */))
const _7e136c0d = () => interopDefault(import('../../../pages/fund/_slug/application.vue' /* webpackChunkName: "pages/fund/_slug/application" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/callback",
    component: _6127805e,
    name: "callback___en"
  }, {
    path: "/error",
    component: _3b967dac,
    name: "error___en"
  }, {
    path: "/es",
    component: _105f4114,
    name: "index___es"
  }, {
    path: "/financials",
    component: _bf4489ce,
    name: "financials___en"
  }, {
    path: "/fund",
    component: _a1adbbd8,
    name: "fund___en"
  }, {
    path: "/settings",
    component: _1cd0781c,
    name: "settings___en"
  }, {
    path: "/surveys",
    component: _58744c7d,
    name: "surveys___en"
  }, {
    path: "/temporarily-down",
    component: _00403d0d,
    name: "temporarily-down___en"
  }, {
    path: "/ui-kit",
    component: _667c78a9,
    name: "ui-kit___en"
  }, {
    path: "/es/callback",
    component: _6127805e,
    name: "callback___es"
  }, {
    path: "/es/error",
    component: _3b967dac,
    name: "error___es"
  }, {
    path: "/es/financials",
    component: _bf4489ce,
    name: "financials___es"
  }, {
    path: "/es/fund",
    component: _a1adbbd8,
    name: "fund___es"
  }, {
    path: "/es/settings",
    component: _1cd0781c,
    name: "settings___es"
  }, {
    path: "/es/surveys",
    component: _58744c7d,
    name: "surveys___es"
  }, {
    path: "/es/temporarily-down",
    component: _00403d0d,
    name: "temporarily-down___es"
  }, {
    path: "/es/ui-kit",
    component: _667c78a9,
    name: "ui-kit___es"
  }, {
    path: "/settings/applications",
    component: _1657b89a,
    name: "settings-applications___en"
  }, {
    path: "/settings/join-movement",
    component: _5a67d912,
    name: "settings-join-movement___en"
  }, {
    path: "/settings/payout-methods",
    component: _62d8d9ca,
    name: "settings-payout-methods___en"
  }, {
    path: "/settings/profile",
    component: _9c2269e8,
    name: "settings-profile___en"
  }, {
    path: "/settings/security",
    component: _d784345a,
    name: "settings-security___en"
  }, {
    path: "/es/settings/applications",
    component: _1657b89a,
    name: "settings-applications___es"
  }, {
    path: "/es/settings/join-movement",
    component: _5a67d912,
    name: "settings-join-movement___es"
  }, {
    path: "/es/settings/payout-methods",
    component: _62d8d9ca,
    name: "settings-payout-methods___es"
  }, {
    path: "/es/settings/profile",
    component: _9c2269e8,
    name: "settings-profile___es"
  }, {
    path: "/es/settings/security",
    component: _d784345a,
    name: "settings-security___es"
  }, {
    path: "/financials/payments/history",
    component: _0e6bb13b,
    name: "financials-payments-history___en"
  }, {
    path: "/settings/profile/address",
    component: _639d08b1,
    name: "settings-profile-address___en"
  }, {
    path: "/settings/profile/basic",
    component: _7cc96868,
    name: "settings-profile-basic___en"
  }, {
    path: "/settings/profile/basic_household_info",
    component: _1aa39116,
    name: "settings-profile-basic_household_info___en"
  }, {
    path: "/settings/profile/contact",
    component: _3a8e624c,
    name: "settings-profile-contact___en"
  }, {
    path: "/settings/profile/contact_address_info",
    component: _1c98998e,
    name: "settings-profile-contact_address_info___en"
  }, {
    path: "/settings/profile/household",
    component: _6795ce5c,
    name: "settings-profile-household___en"
  }, {
    path: "/settings/profile/notification",
    component: _eea6e9be,
    name: "settings-profile-notification___en"
  }, {
    path: "/settings/security/privacy-legal",
    component: _20ce9735,
    name: "settings-security-privacy-legal___en"
  }, {
    path: "/settings/security/questions",
    component: _b53dff5e,
    name: "settings-security-questions___en"
  }, {
    path: "/es/financials/payments/history",
    component: _0e6bb13b,
    name: "financials-payments-history___es"
  }, {
    path: "/es/settings/profile/address",
    component: _639d08b1,
    name: "settings-profile-address___es"
  }, {
    path: "/es/settings/profile/basic",
    component: _7cc96868,
    name: "settings-profile-basic___es"
  }, {
    path: "/es/settings/profile/basic_household_info",
    component: _1aa39116,
    name: "settings-profile-basic_household_info___es"
  }, {
    path: "/es/settings/profile/contact",
    component: _3a8e624c,
    name: "settings-profile-contact___es"
  }, {
    path: "/es/settings/profile/contact_address_info",
    component: _1c98998e,
    name: "settings-profile-contact_address_info___es"
  }, {
    path: "/es/settings/profile/household",
    component: _6795ce5c,
    name: "settings-profile-household___es"
  }, {
    path: "/es/settings/profile/notification",
    component: _eea6e9be,
    name: "settings-profile-notification___es"
  }, {
    path: "/es/settings/security/privacy-legal",
    component: _20ce9735,
    name: "settings-security-privacy-legal___es"
  }, {
    path: "/es/settings/security/questions",
    component: _b53dff5e,
    name: "settings-security-questions___es"
  }, {
    path: "/settings/profile/address/create",
    component: _37b8582d,
    name: "settings-profile-address-create___en"
  }, {
    path: "/settings/profile/household/create",
    component: _9a4f703c,
    name: "settings-profile-household-create___en"
  }, {
    path: "/settings/security/questions/edit",
    component: _2c8154db,
    name: "settings-security-questions-edit___en"
  }, {
    path: "/es/settings/profile/address/create",
    component: _37b8582d,
    name: "settings-profile-address-create___es"
  }, {
    path: "/es/settings/profile/household/create",
    component: _9a4f703c,
    name: "settings-profile-household-create___es"
  }, {
    path: "/es/settings/security/questions/edit",
    component: _2c8154db,
    name: "settings-security-questions-edit___es"
  }, {
    path: "/es/settings/profile/address/:uuid",
    component: _0dc72f0e,
    name: "settings-profile-address-uuid___es"
  }, {
    path: "/es/settings/profile/household/:uuid",
    component: _05d5a3b8,
    name: "settings-profile-household-uuid___es"
  }, {
    path: "/es/financials/contracts/:contractid",
    component: _55a800e8,
    name: "financials-contracts-contractid___es"
  }, {
    path: "/es/financials/offers/:offerid",
    component: _5f57d67a,
    name: "financials-offers-offerid___es"
  }, {
    path: "/es/financials/payments/:paymentid",
    component: _7b3e118e,
    name: "financials-payments-paymentid___es"
  }, {
    path: "/es/financials/uf/:accountid",
    component: _2e137d91,
    name: "financials-uf-accountid___es"
  }, {
    path: "/settings/profile/address/:uuid",
    component: _0dc72f0e,
    name: "settings-profile-address-uuid___en"
  }, {
    path: "/settings/profile/household/:uuid",
    component: _05d5a3b8,
    name: "settings-profile-household-uuid___en"
  }, {
    path: "/es/financials/uf/:accountid?/confirm",
    component: _0adb3282,
    name: "financials-uf-accountid-confirm___es"
  }, {
    path: "/es/fund/:slug",
    component: _ae538362,
    name: "fund-slug___es"
  }, {
    path: "/financials/contracts/:contractid",
    component: _55a800e8,
    name: "financials-contracts-contractid___en"
  }, {
    path: "/financials/offers/:offerid",
    component: _5f57d67a,
    name: "financials-offers-offerid___en"
  }, {
    path: "/financials/payments/:paymentid",
    component: _7b3e118e,
    name: "financials-payments-paymentid___en"
  }, {
    path: "/financials/uf/:accountid",
    component: _2e137d91,
    name: "financials-uf-accountid___en"
  }, {
    path: "/es/fund/:slug/application",
    component: _7e136c0d,
    name: "fund-slug-application___es"
  }, {
    path: "/financials/uf/:accountid?/confirm",
    component: _0adb3282,
    name: "financials-uf-accountid-confirm___en"
  }, {
    path: "/fund/:slug",
    component: _ae538362,
    name: "fund-slug___en"
  }, {
    path: "/fund/:slug/application",
    component: _7e136c0d,
    name: "fund-slug-application___en"
  }, {
    path: "/",
    component: _105f4114,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
